import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { useIntl } from 'react-intl';

const WeatherContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: calc(50% - 10vh);
  width: 10vw;
  height: 10vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: white;
  margin: 0px;
  padding: 0px;
  border-top: 1px solid white;
  border-left: 1px solid white;
  border-right: 1px solid white;
  border-top-left-radius: 5vw;
  border-top-right-radius: 5vw;
  box-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  transition: left 0.15s ease-out, width 0.15s ease-out, height 0.15s ease-out;
  z-index: 20;
  &:hover {
    width: 100%;
    ${"" /* height: auto; */}
    left: 0;
    border-left: 0;
    border-right: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    transition: left 0.15s ease-in, width 0.15s ease-in, height 0.15s ease-in;
    .icon-text {
      display: none;
    }
    ul {
      display: flex;
    }
  }

  .icon-text {
    width: 100%;
    img {
      z-index: 0;
      position: absolute;
      max-width: 5vw;
      max-height: 10vh;
      left: 2.5vw;
      bottom: 2vh;
    }
    .tempTitle {
      z-index: 5;
      width: 100%;
      position: absolute;
      font-size: calc(5px + 1.5vmin);
      padding: 0;
      margin: 0;
      text-align: center;
      font-weight: 600;
      align-self: flex-end;
      bottom: 1vh;
    }
  }

  ul {
    width: 100%;
    display: none;
    flex-direction: row;
    text-align: left;
    justify-content: space-between;
    z-index: 5;
    li {
      div {
        margin: 0 10px;
      }
      p {
        padding: 0;
        margin: 0 10px;
      }
    }
  }
`;

const TransBg = styled.div`
background-color: black;
opacity: .5;
z-index: 0;
width: 100%;
height: 100%;
position: absolute;
`;

const Weather = () => {
  // console.log(useIntl)
  const [city, setCity] = useState("");
  const [main, setMain] = useState("");
  const [desc, setsetDesc] = useState("");
  const [temp, setTemp] = useState("");
  const [feelsLike, setFeelsLike] = useState("");
  const [tempMin, setTempMin] = useState("");
  const [tempMax, setTempMax] = useState("");
  const red = "crimson";
  const blue = "lightskyblue";
  const textColor = "grey";
  const weatherLi = [
    { text: "City:", value: city, color: textColor },
    { text: "Weather:", value: main, color: textColor },
    { text: "Description:", value: desc, color: textColor },
    {
      text: "Temperature:",
      value: temp + "°C",
      color: temp > 0 ? red : blue
    },
    {
      text: "Feels like:",
      value: feelsLike + "°C",
      color: feelsLike > 0 ? red : blue
    },
    {
      text: "Temp Min:",
      value: tempMin + "°C",
      color: tempMin > 0 ? red : blue
    },
    {
      text: "Temp Max:",
      value: tempMax + "°C",
      color: tempMax > 0 ? red : blue
    }
  ];

  function getWeather() {
    // TODO: Bryt ut api call
    // console.log(intl.locale)
    fetch(
      "https://api.openweathermap.org/data/2.5/weather?q=Stockholm,se&units=metric&appid=477d350000cd206edf81fd3973b7f625"
    ).then(response => {
      response.json().then(data => {
        setCity(data.name);
        setMain(data.weather[0].main);
        setsetDesc(data.weather[0].description);
        setTemp(data.main.temp);
        setFeelsLike(data.main.feels_like);
        setTempMin(data.main.temp_min);
        setTempMax(data.main.temp_max);
      });
    });
  }

  function iconUrl() {
    const baseUrl = "https://openweathermap.org/img/wn/";
    const date = new Date();
    const daytime =
      date.getHours() >= 18 ? "n" : date.getHours() >= 6 ? "d" : "n";
    switch (main) {
      case "Clear":
        return `${baseUrl}01${daytime}@2x.png`;
      case "Drizzle":
        return `${baseUrl}09${daytime}@2x.png`;
      case "Thunderstorm":
        return `${baseUrl}11${daytime}@2x.png`;
      case "Snow":
        return `${baseUrl}13${daytime}@2x.png`;
      case "Clouds":
        if (desc === "broken clouds" || desc === "overcast clouds") {
          return `${baseUrl}04${daytime}@2x.png`;
        } else {
          return `${baseUrl}02${daytime}@2x.png`;
        }
      case "Rain":
        if (desc === "freezing rain") {
          return `${baseUrl}13${daytime}@2x.png`;
        } else if (
          desc === "light intensity shower rain" ||
          desc === "shower rain" ||
          desc === "heavy intensity shower rain" ||
          desc === "ragged shower rain"
        ) {
          return `${baseUrl}09${daytime}@2x.png`;
        } else {
          return `${baseUrl}10${daytime}@2x.png`;
        }

      default:
        return `${baseUrl}50${daytime}@2x.png`;
    }
  }
  useEffect(() => {
    getWeather();
    setInterval(() => {
      getWeather();
    }, 600000);
  }, [temp]);
  return (
    <WeatherContainer>
    <TransBg></TransBg>
      <div className="icon-text">
        <img src={iconUrl()} alt=""></img>
        <p className="tempTitle" style={{ color: weatherLi[3].color }}>
          {weatherLi[3].value}
        </p>
      </div>
      <ul>
        {weatherLi.map((value, index) => {
          return (
            <li key={index}>
              <div>{value.text}</div>
              <p style={{ color: value.color }}>
                <b>{value.value}</b>
              </p>
            </li>
          );
        })}
      </ul>
    </WeatherContainer>
  );
};

export default Weather;
